<template>
  <div class="log-container">
    <transition name="fade" mode="out-in" appear>
      <div key="login" v-if="!user" class="login-wrap">
        <LoadAnimation v-show="loading" class="load-signIn" :loadSettings="loadSettings"/>
        <oButton class="btn-login" @click="login" buttonText="Login" />
        <div class="logo-wrap">
          <span>{{ msg }}</span>
        </div>
      </div>

      <div key="logout" v-if="user" class="logout-wrap">
        <ul class="nav">
          <li>
            <router-link :to="{name: 'home'}" exact>Home</router-link>
          </li>
          <li>
            <router-link :to="{name: 'list'}" exact>List</router-link>
          </li>
          <li>
            <a @click="hdlRegister">Register</a>
          </li>
        </ul>
        <div class="userlog">
          <oButtonToggle :checkStatus="statusLoader" @click="hdlToggle"/>
          <p>{{ user }}</p>
          <oButton @click="logout" buttonText="Logout" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import AuthService from '../services/auth.service'
import oButton from './oButton'
import LoadAnimation from './LoadAnimation'
import oButtonToggle from './oButtonToggle'

export default {
  name: 'LogHeader',
  components: {
    oButton,
    LoadAnimation,
    oButtonToggle
  },
  props: ['userValue', 'token', 'statusLoader'],
  data() {
    return {
      msg: 'Exflow onboard portal',
      user: this.userValue || null,
      userToken: this.token,
      loading: false,
      loadSettings: this.loadSettings || {animationStyle: 'zoom', message: 'This may take a while..'}
    }
  },
  created() {
    this.authService = new AuthService()
    if (sessionStorage) {
      this.user = JSON.parse(sessionStorage.getItem('user'))
      this.userToken = sessionStorage.getItem('msal.idtoken')
      this.$emit('getUser', this.user)
      this.$emit('getToken', this.userToken)
    }
  },
  watch: {
    token(t) {
      this.userToken = t
    },
    userValue(u) {
      this.user = u      
    },
    deep: true, // include nested array
  },
  methods: {
    hdlRegister(){
      this.$emit('change', {
        hybridConnection: false,
        hybridConnectionHost: '',
        hybridConnectionPort: 0,
        authentication: 'aad',
        appControlMergeFile:
          'App.NAV.WS.xml?{DebugLog}=false;{FormsTestSite}=false;{PurchaseDisabled}=true;{UseNAVSSOEmailing}=true',
        formsTestSitePassword: '',
        deployType: 'npe',
      })
      this.$router.push({ name: 'vnext' })
    },
    logout() {
      this.authService.logout()
      sessionStorage.clear()
    },

    login() {
      this.loading = true
      this.loadSettings = {animationStyle: 'zoom', message: 'Verifying'}
      this.authService.login().then(user => {
         if (user) {
            let u = user.user
            let t = user.token
            this.$http('api/register', 'GET', t)
                .then( data => {
                  this.loading = false
                  this.user = u
                  this.userToken = t 
                  this.$emit('getToken', this.userToken)
                  this.$emit('getUser', this.user)
                  this.$emit('getDynamics', data)
                  sessionStorage.setItem('dynamics', JSON.stringify(data.dynamics))
                })
                .catch(e => {
                  this.loading = false
                  this.$toasted.global.error_message({message: 'You do not have access. Please contact our support team for Registration'})
                })
          } else {
            this.loading = false
            this.$toasted.global.error_message({message: "Login failed"})
          }
      })
      .catch(e => {
        this.loading = false
        this.$toasted.global.error_message({message: "Login cancelled"})
      })
    },
    hdlToggle(e){
      this.$emit('getToggle', e)
    }
  },
}
</script>


<style scoped>
.log-container,
.nav,
.login-wrap,
.logout-wrap,
.userlog {
  display: flex;
}
h2,
h3 {
  padding: 15px;
}
h2 {
  text-align: center;
}
.userlog p {
  display: none;
  font-size: 14px;
  padding: 15px;
}
.log-container {
  width: 100%;
  margin: 0 auto;
  max-width: 1060px;
  padding: 20px 0 20px 0;
  /* margin-bottom: 20px; */
}
.logout-wrap {
  width: 100%;
  align-items: center;
}
.login-wrap {
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  min-height: 300px;
  min-width: 290px;
  margin: 0 auto;
  margin-top: 140px;
}
.logo-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
}
.logo-wrap img {
  width: 100%;
  max-width: 150px;
  height: auto;
  margin: 0 auto;
}

.login-wrap span {
  color: var(--o-primary);
  padding-left: 1px;
  font-size: 30px;
  font-weight: bold;
}
.logout-wrap {
  justify-content: space-between;
}
.nav {
  list-style: none;
  padding-left: 0;
  margin-left: 10px;
}
.nav a {
  padding: 10px;
  text-decoration: none;
  color: var(--o-primary);
}
.nav a:hover {
  color: var(--o-text-on-bg);
  background-color: var(--o-primary);
}
.nav a:visited {
  color: var(--o-primary);
}
.nav a:visited:hover {
  color: var(--o-text-on-bg);
}
.userlog {
  padding-right: 10px;
  align-items: center;
}
.router-link-active {
  color: var(--o-primary);
  border-bottom: 3px solid var(--o-primary);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.load-signIn{
  position: absolute;
  top: 80px;
}
/* ================================= 
  Media Queries
==================================== */

@media (min-width: 769px) {
  .nav a {
    padding: 20px;
  }
  .login-wrap{
    margin-top: 280px;
  }
  .logout-wrap {
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
  }
  .userlog p {
    display: block;
  }
}
@media (min-width: 1025px) {
  .nav a {
    padding: 20px;
  }
  .login-wrap{
    margin-top: 380px;
  }
  /* .log-container {
    margin-bottom: 50px;
  } */
  .load-signIn{
    top: 100px;
  }
  .userlog p {
    display: block;
  }
}
</style>
